<template>
  <div class="map-tools">
    <div v-show="showDrawTool!==false">
      <!-- <Icon type="big" name="icon-spot-b" color content="点" @click="onDrawPoint" :disabled="isDrawState"></Icon> -->
      <el-dropdown placement="bottom-start" :disabled="isDrawState||isShowSpaceSearchDraw||permissionLevel <= PermissionLevel.LOOKER">
        <span class="el-dropdown-link">
          <Icon type="big" name="icon-spot-b" color content="点"></Icon>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <div class="popover-content">
            <el-dropdown-item @click.native="onDrawPoint">
              <svg width="1em" height="1em" aria-hidden="true" fill="currentColor">
                <use xlink:href="#icon-map"></use>
              </svg>
              点击定位
            </el-dropdown-item>
            <el-dropdown-item @click.native="onInputPoint">
              <svg width="1em" height="1em" aria-hidden="true" fill="currentColor">
                <use xlink:href="#icon-coordinate"></use>
              </svg>
              坐标定位
            </el-dropdown-item>
            <el-dropdown-item @click.native="importKML('point')">
              <svg width="1em" height="1em" aria-hidden="true" fill="currentColor">
                <use xlink:href="#icon-kml1"></use>
              </svg>
              KML导入
            </el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <Icon type="big" name="icon-Line-b" color content="线" @click="onDrawLine" :disabled="isDrawState"></Icon> -->
      <el-dropdown placement="bottom-start" :disabled="isDrawState||isShowSpaceSearchDraw || permissionLevel <= PermissionLevel.LOOKER">
        <span class="el-dropdown-link">
          <Icon type="big" name="icon-Line-b" color content="线"></Icon>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <div class="popover-content">
            <el-dropdown-item @click.native="onDrawLine">
              <svg width="1em" height="1em" aria-hidden="true" fill="currentColor">
                <use xlink:href="#icon-line"></use>
              </svg>
              绘制直线
            </el-dropdown-item>
            <el-dropdown-item @click.native="onDrawCurve">
              <svg width="1em" height="1em" aria-hidden="true" fill="currentColor">
                <use xlink:href="#icon-curve"></use>
              </svg>
              绘制曲线
            </el-dropdown-item>
            <el-dropdown-item @click.native="importKML('polyline')">
              <svg width="1em" height="1em" aria-hidden="true" fill="currentColor">
                <use xlink:href="#icon-kml1"></use>
              </svg>
              KML导入
            </el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <Icon type="big" name="icon-noodles-b" color content="面" @click="onDrawPolygon" :disabled="isDrawState"></Icon> -->
      <el-dropdown placement="bottom-start" :disabled="isDrawState||isShowSpaceSearchDraw || permissionLevel <= PermissionLevel.LOOKER">
        <span class="el-dropdown-link">
          <Icon type="big" name="icon-noodles-b" color content="面"></Icon>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <div class="popover-content">
            <el-dropdown-item @click.native="onDrawPolygon">
              <svg width="1em" height="1em" aria-hidden="true" fill="currentColor">
                <use xlink:href="#icon-area"></use>
              </svg>
              绘制面
            </el-dropdown-item>
            <el-dropdown-item @click.native="onDrawCircle">
              <svg width="1em" height="1em" aria-hidden="true" fill="currentColor">
                <use xlink:href="#icon-circular"></use>
              </svg>
              绘制圆
            </el-dropdown-item>
            <el-dropdown-item @click.native="importKML('polygon')">
              <svg width="1em" height="1em" aria-hidden="true" fill="currentColor">
                <use xlink:href="#icon-kml1"></use>
              </svg>
              KML导入
            </el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dropdown v-show="showMeasureTool!==false" placement="bottom-start" :disabled="isDrawState||isShowSpaceSearchDraw">
      <span class="el-dropdown-link">
        <Icon type="big" name="icon-measure1" color content="测量工具"></Icon>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <div class="popover-content">
          <el-dropdown-item @click.native="onDistance">
            <svg width="1em" height="1em" aria-hidden="true" fill="currentColor">
              <use xlink:href="#icon-Distance1"></use>
            </svg>
            距离测量
          </el-dropdown-item>
          <el-dropdown-item @click.native="onArea">
            <svg width="1em" height="1em" aria-hidden="true" fill="currentColor">
              <use xlink:href="#icon-area1"></use>
            </svg>
            面积测量
          </el-dropdown-item>
          <el-dropdown-item @click.native="volumeMeasure">
            <svg width="1em" height="1em" aria-hidden="true" fill="currentColor">
              <use xlink:href="#icon-Soil"></use>
            </svg>
            填挖方测量
          </el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dropdown v-show="showAnalyseTool!==false" placement="bottom-start" :disabled="isDrawState||isShowSpaceSearchDraw">
      <span class="el-dropdown-link">
        <Icon type="big" name="icon-analysis" color content="空间分析"></Icon>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <div class="popover-content">
          <el-dropdown-item @click.native="visibilityAnalysis" v-show="showAnalyseTool.visibilityAnalysis!==false">
            <svg width="1em" height="1em" aria-hidden="true" fill="currentColor">
              <use xlink:href="#icon-Intervisibility"></use>
            </svg>
            通视分析
          </el-dropdown-item>
          <el-dropdown-item @click.native="viewableAnalysis" v-show="showAnalyseTool.viewableAnalysis!==false">
            <svg width="1em" height="1em" aria-hidden="true" fill="currentColor">
              <use xlink:href="#icon-visual"></use>
            </svg>
            可视域分析
          </el-dropdown-item>
          <el-dropdown-item @click.native="cameraView" v-show="showAnalyseTool.cameraView!==false">
            <svg width="1em" height="1em" aria-hidden="true" fill="currentColor">
              <use xlink:href="#icon-view"></use>
            </svg>
            视野分析
          </el-dropdown-item>
          <el-dropdown-item @click.native="splitScreenContrast" v-show="showAnalyseTool.splitScreenContrast!==false">
            <svg width="1em" height="1em" aria-hidden="true" fill="currentColor">
              <use xlink:href="#icon-contrast"></use>
            </svg>
            对比分析
          </el-dropdown-item>
          <el-dropdown-item @click.native="spaceSearch" v-show="showAnalyseTool.spaceSearch!==false">
            <svg width="1em" height="1em" aria-hidden="true" fill="currentColor">
              <use xlink:href="#icon-search-map"></use>
            </svg>
            空间查询
          </el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
// import * as markerStyles from '@/utils/markerStyles'
import { mapGetters } from 'vuex'
import { PermissionLevel } from '@/configs/constants'
export default {
  name: 'MapTools',
  computed: {
    ...mapGetters(['isDrawState', 'isShowSpaceSearchDraw', 'permissionLevel'])
  },
  inject: ['shared'],
  props: {
    // 是否显示标绘工具
    showDrawTool: {
      type: Boolean,
      default: true
    },
    // 是否显示测量工具
    showMeasureTool: {
      type: Boolean,
      default: true
    },
    // 是否显示分析工具
    showAnalyseTool: {
      type: [Boolean, Object],
      default: true
    }
  },
  data () {
    return {
      isDrawing: false,
      entitiesList: [],
      PermissionLevel
    }
  },
  watch: {

  },
  mounted () {
    this.entitiesList = []
  },
  beforeDestroy () {
    this.clearAllEntity()
  },
  methods: {
    onDrawPoint () {
      // this.isDrawing = true
      this.$emit('drawBegin')
      this.$cesiumPlus.drawHandler.draw(CesiumPlus.DrawMode.Marker, {
        clampMode: CesiumPlus.ClampMode.GroundAndModel,
        drawEndCall: (position, entity) => {
          if (entity) {
            this.$emit('drawEndMsg', { type: this.$cesiumPlus.drawHandler.drawMode, entity: entity })
          }
        },
        styleList: [CesiumPlus.BillboardStyle.Default()]
      })
    },
    onInputPoint () {
      this.$emit('drawBegin')
      this.$emit('inputPoint')
    },
    onDrawLine () {
      // this.isDrawing = true
      this.$emit('drawBegin')
      this.$cesiumPlus.drawHandler.draw(CesiumPlus.DrawMode.Polyline, {
        clampMode: CesiumPlus.ClampMode.GroundAndModel,
        drawEndCall: (position, entity) => {
          if (entity) {
            this.$emit('drawEndMsg', { type: this.$cesiumPlus.drawHandler.drawMode, entity: entity })
          }
        },
        styleList: [CesiumPlus.PolylineStyle.Default()]
      })
    },
    onDrawCurve () {
      this.$emit('drawBegin')
      this.$cesiumPlus.drawHandler.draw(CesiumPlus.DrawMode.Curve, {
        clampMode: CesiumPlus.ClampMode.GroundAndModel,
        drawEndCall: (positions, entity) => {
          if (entity) {
            this.$emit('drawEndMsg', { type: this.$cesiumPlus.drawHandler.drawMode, entity: entity, positions: positions })
          }
        },
        styleList: [CesiumPlus.PolylineStyle.Default()]
      })
    },
    onDrawPolygon () {
      // this.isDrawing = true
      this.$emit('drawBegin')
      this.$cesiumPlus.drawHandler.draw(CesiumPlus.DrawMode.Polygon, {
        clampMode: CesiumPlus.ClampMode.GroundAndModel,
        drawEndCall: (position, entity) => {
          if (entity) {
            this.$emit('drawEndMsg', { type: this.$cesiumPlus.drawHandler.drawMode, entity: entity })
          }
        },
        styleList: [CesiumPlus.PolygonStyle.Default()]
      })
    },
    onDrawCircle () {
      this.$emit('drawBegin')
      this.$cesiumPlus.drawHandler.draw(CesiumPlus.DrawMode.Circle, {
        clampMode: CesiumPlus.ClampMode.GroundAndModel,
        drawEndCall: (position, entity) => {
          if (entity) {
            this.$emit('drawEndMsg', { type: this.$cesiumPlus.drawHandler.drawMode, entity: entity })
          }
        },
        styleList: [CesiumPlus.PolygonStyle.Default()]
      })
    },
    onDistance () {
      this.$emit('drawBegin')
      this.$measureTools.distance()
    },
    onArea () {
      this.$emit('drawBegin')
      this.$measureTools.area()
    },
    // 创建测量结果
    createMeasureLabel (entity, position, text) {
      entity.position = position
      if (!entity.label) {
        entity.label = new Cesium.LabelGraphics({
          text: text,
          font: '14px sans-serif',
          pixelOffset: new Cesium.Cartesian2(0, -50),
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.HorizontalOrigin.CENTER,
          showBackground: false,
          fillColor: Cesium.Color.fromCssColorString('#FFFFFF'),
          outlineColor: Cesium.Color.fromCssColorString('#000000'),
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          heightReference: Cesium.HeightReference.NONE,
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
          outlineWidth: 30,
          show: true
        })
      } else {
        entity.label.text = text
      }

      // entity.billboard = new Cesium.BillboardGraphics({
      //   image: require('../../../assets/textures/close.png'),
      //   pixelOffset: new Cesium.Cartesian2(0, -10),
      //   heightReference: Cesium.HeightReference.NONE,
      //   disableDepthTestDistance: Number.POSITIVE_INFINITY
      // })
    },
    createCloseBillboard (entity) {
      if (!entity.billboard) {
        entity.billboard = new Cesium.BillboardGraphics({
          image: require('../../../assets/textures/close.png'),
          pixelOffset: new Cesium.Cartesian2(0, -10),
          heightReference: Cesium.HeightReference.NONE,
          disableDepthTestDistance: Number.POSITIVE_INFINITY
        })
      }
    },

    cameraView () {
      this.$emit('drawBegin')
      this.$measureTools.cameraView()
    },
    // 可视域分析
    viewableAnalysis () {
      this.$emit('drawBegin')
      this.$measureTools.viewableAnalysis()

      // this.$cesiumPlus.drawHandler.draw(CesiumPlus.DrawMode.Segment, {
      //   clampMode: 2,
      //   drawUpdateCall: (position, entity) => {
      //     // this.$store.dispatch('setAllowDrawState', false)
      //     const positions = entity.polyline.positions.getValue(Cesium.JulianDate.now())
      //     if (positions.length < 2) {
      //       return
      //     }
      //     this.$cesiumPlus.viewShed3D.analyze({
      //       viewPosition: positions[0],
      //       viewPositionEnd: positions[1]
      //     })
      //     entity.polyline.show = false
      //   },
      //   drawEndCall: (position, entity) => {
      //     const positions = entity.polyline.positions.getValue(Cesium.JulianDate.now())
      //     this.createMeasureLabel(entity, positions[0])
      //     this.createCloseBillboard(entity)
      //     this.$store.commit('SELECT_SHOWVIEWSHED3DBOX', true)
      //     this.$store.commit('SELECT_VIEWSHED3DDATA', {
      //       horizontalViewAngle: this.$cesiumPlus.viewShed3D._horizontalViewAngle,
      //       verticalViewAngle: this.$cesiumPlus.viewShed3D._verticalViewAngle,
      //       viewDistance: this.$cesiumPlus.viewShed3D._viewDistance,
      //       viewHeading: this.$cesiumPlus.viewShed3D._viewHeading,
      //       viewPitch: this.$cesiumPlus.viewShed3D._viewPitch,
      //       alpha: this.$cesiumPlus.viewShed3D._alpha
      //     })
      //     this.$nextTick(() => {
      //       this.$store.commit('SET_DRAWSTATE', true)
      //     })
      //     this.entitiesList.push(entity.id)
      //   },
      //   escCall: () => {
      //     // 清除可视域分析
      //     this.$cesiumPlus.viewShed3D.clear()
      //     this.$cesiumPlus.viewShed3D.remove()
      //     // 关闭可视域分析弹窗
      //     this.$store.commit('SET_DRAWSTATE', false)
      //   },
      //   styleList: [
      //     new CesiumPlus.PolylineStyle({
      //       material: new Cesium.PolylineArrowMaterialProperty(),
      //       width: 10
      //     })
      //   ],
      //   properties: {
      //     labelAlwayShow: true,
      //     measureClose: true,
      //     isviewShed3D: true
      //   }
      // })
    },
    // 通视分析
    visibilityAnalysis () {
      this.$emit('drawBegin')
      this.$measureTools.visibilityAnalysis()
    },
    // 填挖方测量
    volumeMeasure () {
      this.$emit('drawBegin')
      this.$measureTools.volumeMeasure()
    },
    // 清除所有测量entity
    clearAllEntity () {
      this.$measureTools.clearAllEntity()
      // 清除可视域分析
      this.$cesiumPlus.viewShed3D.remove()
      // 关闭可视域分析弹窗
      this.$store.commit('SELECT_SHOWVIEWSHED3DBOX', false)
      this.$store.commit('SET_DRAWSTATE', false)
    },
    // 调用分屏对比的功能
    splitScreenContrast () {
      this.$store.commit('SELECT_SPLITSCREENCONTRAST', true)
    },
    // 调用导入KML的功能
    importKML (type) {
      this.$store.commit('SELECT_IMPORTKML', {
        show: true,
        type
      })
    },
    // 空间查询
    spaceSearch () {
      this.$emit('drawBegin')
      this.$nextTick(() => {
        this.$store.dispatch('setDrawState', true)
        this.$store.commit('SELECT_ISSHOWSPACESEARCHDRAW', true)
        this.$store.commit('SELECT_ISSHOWSPACETOOL', true)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.map-tools{
  display: flex;
  justify-content: flex-end;
  padding: 4px 0px;
  height: 40px;
  >.custom-icon{
    margin-right: 10px;
  }
  .el-dropdown{
    width: 60px;
    text-align: center;
    border-radius: 4px;
    padding-right: 7px;
    &:hover{
      background: rgba(255,255,255,0.1);
      .custom-icon{
        background: unset;
      }
    }
    .el-icon--right{
      position: relative;
      top: -4px;
      color: #eeeeee;
      transform: translateX(-5px);
      font-size: 12px;
    }
  }
}
</style>
